import React from "react";
import  MultiSelect from "react-multi-select-component";
import 'assets/css/custom.css';
import { useTranslation } from 'react-i18next';


const CustomMultiSelect = props => {
    const { t, i18n } = useTranslation();
    
    const filterOptions = (options, filter) => {
        if (!filter) {
          return options;
        }
        const filteredOptions = options.filter((obj => {
            return obj.label.toLowerCase().includes(filter.toLowerCase())
        }))
        return filteredOptions;
      };

    return (
        <div>
            <MultiSelect
                options={props.options} 
                // labelledBy={"SelectUsers"}
                value={props.selectChildValue}
                onChange={props.changed}
                filterOptions={filterOptions}
                overrideStrings={
                    {search: `${t("Search")}`,selectSomeItems: `${t("Select")}`}
                    }
            />
        </div>
    );
}

export default CustomMultiSelect;